const initialState = {
  saveThoughtPending: false,
  saveThoughtError: null,
  suggestThoughtPending: false,
  suggestThoughtError: null,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/home/redux/initialState.js